import { NgIf } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RadiosErrorFieldComponent } from '@components/radios-error-field/radios-error-field.component';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { QuestionnaireAnswers } from '@enums/questionnaire-answers';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { environment } from '@environments/environment';
import { SelectableOption } from '@models/selectable-option';
import { ConsultationStorageService } from '@services/consultation-storage.service';
import { FormService } from '@services/form.service';

@Component({
  selector: 'app-sexual-performance',
  imports: [UpsellCardComponent, NgIf, RadiosErrorFieldComponent],
  templateUrl: './sexual-performance.component.html',
})
export class SexualPerformanceComponent {
  @Input() public htmlTitle: string = '<strong>Important: Maintain</strong> Peak Sexual Performance & Confidence';
  @Input() public question: string =
    'We Strongly Recommend ED Medication in your prescription. Would you like to add it to your treatment plan?';

  public edTreatmentForm: FormGroup | null = null;
  public readonly slug: UpsellSlugs = UpsellSlugs.Sildenafil;
  public readonly edTreatmentControlName: string = 'treatment_type';
  public readonly options: SelectableOption[] = [
    new SelectableOption('Yes', QuestionnaireAnswers.Yes),
    new SelectableOption('No', QuestionnaireAnswers.No),
  ];
  public readonly edTreatmentOptions: SelectableOption[] = [
    new SelectableOption('Sildenafil (Generic of Viagra)', UpsellSlugs.Sildenafil),
    new SelectableOption('Tadalafil (Generic of Cialis)', UpsellSlugs.Tadalafil),
    new SelectableOption('Let the Doctor Decide'),
  ];

  private consultationStorageService = inject(ConsultationStorageService);
  private formService = inject(FormService);

  /**
   * Retrieves the additional forms to validate if the address form is enabled.
   */
  public get additionalFormsToValidate(): FormGroup[] {
    return this.edTreatmentForm ? [this.edTreatmentForm] : [];
  }

  /**
   * Retrieves the hints to display in the upsell card, including the price for the ED medication if available in the
   * configuration.
   */
  public get hints(): string[] {
    return [
      `Most patients select this option - only $${
        environment.consultationRequestUpsells[this.slug]?.price
      } for a 30 pill supply.`,
    ];
  }

  /**
   * Store the upsell selected in the local storage service using the current upsell option value.
   */
  public onContinueButtonPressed(optionSelected: string): void {
    if (!this.edTreatmentForm) {
      return;
    }

    const upsellOptionValues = this.options.map((option) => option.value);
    const edTreatmentOptionValues = this.edTreatmentOptions.map((option) => option.value);
    const valuesToFilter = [...upsellOptionValues, ...edTreatmentOptionValues];

    const filteredUpsells = [...this.consultationStorageService.upsells].filter((upsell) => {
      return !valuesToFilter.includes(upsell);
    });

    const treatmentType =
      this.edTreatmentForm.get(this.edTreatmentControlName).value === 'Let the Doctor Decide'
        ? UpsellSlugs.Sildenafil
        : this.edTreatmentForm.get(this.edTreatmentControlName).value;

    this.consultationStorageService.upsells = [treatmentType, ...filteredUpsells];
  }

  /**
   * Configures the ed treatment form based on the current upsell option value.
   */
  public onOptionSelected(optionSelected: string) {
    optionSelected == QuestionnaireAnswers.Yes ? this.setEdTreatmentForm() : (this.edTreatmentForm = null);
  }

  /**
   * Configures the ed treatment form
   */
  private setEdTreatmentForm(): void {
    this.edTreatmentForm = this.formService.edTreatment;
  }
}
